<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" :model="searchForm" ref="searchForm" label-width="70px">
          <el-form-item label="平台单号">
            <el-input v-model.trim="searchForm.orderNo" placeholder="请输入平台单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品编码">
            <el-input v-model.trim="searchForm.skuCode" placeholder="请输入商品编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="searchForm.billStatus" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in orderStatusList" :label="item.name" :key="item.code" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="searchForm.orderType" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in unsaleOrderTypeList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签">
            <el-select v-model="searchForm.orderTag" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="正常"></el-option>
              <el-option label="删除" value="删除"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款时间">
            <form-date-range :form="searchForm" startKey="startTime" endKey="endTime" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="selectList">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" class="green-btn" size="mini" @click="importExcel">导入</el-button>
        <el-button type="primary" size="mini" class="green-btn" @click="addShow">新增</el-button>
        <el-button type="primary" size="mini" @click="uploadForm">编辑</el-button>
        <el-button
          type="primary"
          class="green-btn"
          size="mini"
          @click="exportExcel"
          v-loading.fullscreen.lock="loadingExport"
          element-loading-text="数据导出中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >导出</el-button>
        <el-button type="primary" size="mini" @click="refresh">刷新</el-button>
      </template>
      <el-table
        ref="tableRef"
        border
        stripe
        :data="tableData.records"
        :height="maxTableHeight"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :row-key="(row) => row.id"
      >
        <el-table-column type="selection" width="40" :reserve-selection="true"></el-table-column>
        <el-table-column prop="orderNo" label="平台单号" min-width="170"></el-table-column>
        <el-table-column prop="buyer" label="订单昵称" min-width="150"></el-table-column>
        <el-table-column prop="storeName" label="店铺名称" min-width="180"></el-table-column>
        <el-table-column prop="skuCode" label="商品编码" min-width="180"></el-table-column>
        <el-table-column prop="buyNum" label="购买数量" min-width="100"></el-table-column>
        <el-table-column prop="totalFee" label="成交金额" min-width="100"></el-table-column>
        <el-table-column prop="billStatus" label="订单状态" min-width="100"></el-table-column>
        <el-table-column prop="orderType" label="订单类型" min-width="100"></el-table-column>
        <el-table-column prop="payTime" label="订单付款时间" min-width="160"></el-table-column>
        <el-table-column prop="orderTag" label="标签" min-width="80"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" @click="showDialog(row)">查看修改记录</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <div style="color: #555; float: left;">
            <span>{{ dataUpdateObj.updateContent }}：</span>
            <span>{{ dataUpdateObj.latestUpdateTime }}</span>
          </div>
          <el-pagination
            @size-change="operationSizeChange"
            @current-change="operationCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            :total="tableData.total"
            background
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 新增订单弹窗 -->
    <add-dialog v-if="addDialogVisible" :visible.sync="addDialogVisible" @success="onSearch" />

    <!-- 编辑订单弹窗 -->
    <edit-dialog
      v-if="editDialogVisible"
      :visible.sync="editDialogVisible"
      :selectSpus="selectSpus"
      @success="handleEditSuccess"
    />

    <!-- 订单修改记录弹窗 -->
    <record-dialog
      :visible.sync="recordDialogVisible"
      :orderNo="currentOrderNo"
      :dataId="currentDataId"
    />
  </content-panel>
</template>

<script>
import { debounce } from "@/utils/index";
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import AddDialog from './AddDialog.vue'
import EditDialog from './EditDialog.vue'
import RecordDialog from './RecordDialog.vue'
export default {
  name: "nonSalesOrder",
  mixins: [tableMixin, pagePathMixin],
  components: { AddDialog, EditDialog, RecordDialog },
  data() {
    return {
      loadingExport: false,
      loading: false,
      loadingLog: false,
      searchDialogForm: {
        skuCode: "",
        skuName: "",
      },
      dialog1TableData: [],
      titleName: "",
      addForm: {
        orderNo: "",
      },
      addDialogVisible: false,
      editDialogVisible: false,
      recordDialogVisible: false,
      currentOrderNo: "",
      currentDataId: "",
      checkStores: [],
      stores: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      recordData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchForm: {
        billStatus: "",
        orderTag: "",
        orderNo: "",
        skuCode: "",
        startTime: "",
        endTime: "",
        isExport: 2,
      },
      onRemoveSpuIds: [],
      unsaleOrderTypeList: [],
      selectSpus: [],
      formType: null,
      orderNo: "",
      dataId: "",
      orderStatusList: [],
      dataUpdateObj: {},
      addText: {},
      rules: {
        orderNo: [{ required: true, message: "请输入平台单号", trigger: "blur" }],
      },
    };
  },
  computed: {
    expends() {
      return [];
    },
    windowWidth() {
      return document.body.clientWidth;
    },
  },
  methods: {
    getRowKeys(row) {
      return row.index;
    },
    refresh: debounce(function () {
      const loading = this.$loading({
        lock: true,
        text: "订单状态正在刷新",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.$q.dataImport.refresh({}).then((data) => {
        if (data.code === "200") {
          this.$message.success("刷新成功");
          this.onSearch();
          this.orderStatus();
          this.refreshTime();
          loading.close();
        }
      });
    }, 500),
    refreshTime() {
      this.$q.preSalePlan.getDataRenewal().then((res) => {
        this.dataUpdateObj = res.data[7];
        console.log(res.data[7]);
      });
    },
    uploadForm() {
      if (this.selectSpus.length == 0) {
        this.$message.error("请选择具体的订单");
        return;
      }
      if (this.selectSpus.length > 3) {
        this.$message.error("请选择小于3条订单数量");
        return;
      }
      this.editDialogVisible = true;
    },
    handleEditSuccess() {
      this.$refs.tableRef.clearSelection();
      this.selectSpus = [];
      this.onSearch();
    },
    orderStatus() {
      this.$q.dataImport.unsaleOrderStatus({}).then((data) => {
        if (data.code === "200") {
          this.orderStatusList = data.data.filter(v=>v);
        } else {
          this.$message.error(data.message);
        }
      });
    },

    handleSelectionChange(val) {
      this.onRemoveSpuIds = [];
      console.log("val", val);
      val.forEach((x) => {
        this.onRemoveSpuIds.push(x.id);
      });
      this.selectSpus = val;
      console.log(this.selectSpus);
      // if (val.length === 1) {
      //     this.selectSpus = val
      // }
    },

    addShow() {
      this.addDialogVisible = true;
    },
    showDialog(data) {
      this.currentOrderNo = data.orderNo;
      this.currentDataId = data.dataId;
      this.recordDialogVisible = true;
    },
    resetSearchForm() {
      (this.searchForm = {
        orderTag: "",
        billStatus: "",
        orderNo: "",
        skuCode: "",
        startTime: "",
        endTime: "",
        isExport: 2,
      }),
        this.$refs.tableRef.clearSelection();
      this.$refs.searchForm.resetFields();
      this.checkStores = [];
      this.onSearch();
    },
    selectList() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
        },
      };
      this.$q.dataImport
        .infoListPage({ data: JSON.stringify(param) })
        .then((res) => {
          if (res.code == 200) {
            res.data.records.forEach((v, index) => {
              v.id = v.orderNo + index + ("" + this.tableData.pageNum);
              // console.log(v);
            });
            this.tableData = res.data;
          }
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    operationSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      // 切换每页条数后从第一页搜索
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    operationCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    //弹框表格分页
    onSizeChange(pageSize) {
      this.recordData.pageSize = pageSize;
      this.recordData.pageNum = 1;
      this.operationSearch(this.dataId);
    },
    onCurrentChange(pageNum) {
      this.recordData.pageNum = pageNum;
      this.operationSearch(this.dataId);
    },
    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/nonSalesImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "非销订单导入.xlsx",
          appCode: "ec-pc-new",
        },
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 2147483647;
      this.searchForm.exportTag = true;
      let params = {
        appCode: "ec-pc-new",
        paramMap: {
          ...this.searchForm,
        },
        reportName: "exportNonSalesDataReturnVo",
      };
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      }).finally(_=>{
        loading.close()
      });
    },
    unsaleOrderType() {
      this.$q.dataImport.unsaleOrderType({}).then((data) => {
        if (data.code === "200") {
          this.unsaleOrderTypeList = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
  },
  mounted() {
    // console.log();
    // this.getStores();
    this.unsaleOrderType();
    this.orderStatus();
    this.onSearch();
    this.refreshTime();
  },
};
</script>

<style lang="stylus" scoped>

.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
  border-color: #0BB78E;
  background-color: #0BB78E;
  color: #FFF;
  border-top: 0;
  border-bottom: 0;
}

.ant-divider, .ant-divider-vertical {
  position: relative;
  top: -.06em;
  display: inline-block;
  width: 1px;
  height: .8em;
  margin: 0 6px;
  vertical-align: middle;
  background-color: #0BB78E;
}

.footerBox
  text-align right
  overflow hidden

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

.content
  margin 5px
  >>> .el-header
    padding 8px 0 8px 8px
    border-radius 5px
    overflow hidden
    background #fff
  >>> .el-main
    background #fff
    margin-top 5px
    border-radius 5px
    padding 10px
  >>> .el-form-item
    margin-bottom 10px

.search-container
  overflow hidden
  margin-bottom 10px
  padding 0 20px

  >>> .el-form-item
    margin-bottom 0

.avatar-uploader
  >>> .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden

    &:hover
      border-color: #409EFF;

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.dialogContent {
  max-height: 70vh
  overflow-y: auto
}

.upload-tip
  margin-left 30px
  margin-top -10px

.preview-content
  text-align center

  p
    margin-bottom 10px

  >>> .el-image
    width 200px
    height 200px

>>> .el-dialog__body
  padding 10px 15px

>>> .el-table__expanded-cell
  padding 10px
  background rgb(250, 250, 250)

.dialog-footer
  text-align center

>>> .input .el-input__inner
      width 150px
      height 28px

>>> .el-table__header-wrapper  .el-checkbox{ //隐藏全选
    display: none !important;
}
</style>
